import React from 'react';
import './loading.css';

const Loading = () => {
  return (
    <div className='loading'>
        <h2>Loading....</h2>
    </div>
  )
}

export default Loading